import * as React from 'react';
import {match, Redirect, Route, Switch} from "react-router";
import ContactRouter from "./ContactRouter";
import SiteRouter from "./SiteRouter";
import LeadRouter from "./LeadRouter";
import ScheduleRouter from "./ScheduleRouter";
import JobRouter from "./JobRouter";
import AdminRouter from "./AdminRouter";
import AccountingRouter from "./AccountingRouter";

interface RouteProps {
	/**
	 * Route match url.
	 */
	match: match<any>;
}

/**
 * Body router.
 */
export default class BodyRouter extends React.Component<RouteProps, {}> {
	render() {
		return (
			<Switch>
				<Route path={this.props.match.url + "/contacts"} component={ContactRouter}/>
				<Route path={this.props.match.url + "/sites"} component={SiteRouter}/>
				<Route path={this.props.match.url + "/leads"} component={LeadRouter}/>
				<Route path={this.props.match.url + "/jobs"} component={JobRouter}/>
				<Route path={this.props.match.url + "/schedule"} component={ScheduleRouter}/>
				<Route path={this.props.match.url + "/admin"} component={AdminRouter}/>
				<Route path={this.props.match.url + "/accounting"} component={AccountingRouter}/>
				<Redirect to={this.props.match.url + "/jobs"}/>
			</Switch>
		);
	}
}